import './App.css';
import Contact from './conponents/Contact';
import Message from './conponents/Message';
import { HashRouter as Router, Route, Switch} from 'react-router-dom';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
        <Switch>
        <Route exact path={["/home", "/"]}>
        <Message name="welcome-icon" text="Welcome to My Website"/>
        </Route>
        <Route exact path="/files">
          <Message name="empty-icon" text="No File to Show"/>
          </Route>
        <Route exact path="/contact" component={Contact}/>
        <Route exact path="/links" component={Message}/>
        <Route>
        <Message name="404-icon" text="File Not Found"></Message>
          </Route>
          </Switch>
    </Router>
  );
}

export default App;
